<div class="lock-name">
  <div class="header mt-3 mb-2 pb-3">
    <div class="d-flex justify-content-between">
      <img
        src="/assets/svg/ico-chevron-back-outline.svg"
        alt="back button"
        class="pointer-cursor"
        *ngIf="stepper > 1"
        (click)="navigateBack()"
      />

      <h1 class="modal-title m-auto">{{ 'ADD_A_LOCK' | translate }}</h1>
      <img
        src="/assets/svg/ico-hamburger-close.svg"
        class="cross-button pointer-cursor"
        (click)="closeDialog()"
      />
    </div>

    <div class="d-flex mt-2 pt-2">
      <h2 class="heading1 m-auto">{{ 'NAME_YOUR_LOCK' | translate }}</h2>
    </div>

    <div class="d-flex pt-2">
      <h2 class="heading2 m-auto">
        {{ 'PERSONALIZE_YOUR_LOCK_EXPERIENCE' | translate }}
      </h2>
    </div>
  </div>
  <form [formGroup]="formGroup" (ngSubmit)="submit()" novalidate>
    <div class="form-group rounded-top form-container mb-20">
      <mat-form-field appearance="fill" class="w-100 primary-input">
        <mat-label>{{ 'NAME_ASTERIK' | translate }}</mat-label>
        <input
          matInput
          maxlength="100"
          [placeholder]="'NAME' | translate"
          formControlName="deviceName"
        />
        <mat-error>
          <span *ngIf="formGroup?.controls?.deviceName?.errors?.required">{{
            'YOU_MUST_ENTER_LOCK_NAME' | translate
          }}</span>
        </mat-error>

        <mat-error>
          <span
            *ngIf="
              formGroup?.controls?.deviceName?.errors
                ?.requiredSpecialCharForUnitName
            "
            >{{ 'YOU_MUST_ENTER_VALID_LOCK_NAME' | translate }}</span
          >
          <span
            *ngIf="
              formGroup?.controls?.deviceName?.errors?.firstCharacterIsSpecialCharacter
            "
            >{{
              'LOCK_NAME_SHOULD_NOT_START_WITH_SPECIAL_CHARACTER' | translate
            }}</span
          >
        </mat-error>

        <mat-error *ngIf="formGroup?.controls?.deviceName?.errors?.whitespace"
          >{{ 'EXTRA_WHITE_SPACES_ARE_NOT_SUPPORTED' | translate }}
        </mat-error>
        <mat-error
          *ngIf="
            formGroup?.controls?.deviceName?.errors?.maxlength &&
            !formGroup?.controls?.deviceName?.errors?.requiredSpecialCharForLock
          "
        >
          {{
            commonService.stringInterPolation(
              ("MAXIMUM_OF_CHARACTERS" | translate),
              "50"
            )
          }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="text-center mb-46">
      <div>
        <img src="assets/svg/ico-lock-circle-outline-white.svg" />
      </div>
      <div>
        <h3 class="sub-heading m-auto">{{ 'NAMING_YOUR_LOCK' | translate }}</h3>
      </div>

      <div>
        <p class="desc m-auto">{{ 'GIVEN_A_NAME_TO_YOUR_LOCK' | translate }}</p>
      </div>
    </div>

    <div class="row">
      <div class="col-12 my-1">
        <button
          class="btn btn-danger px-3 w-100 btn-submit"
          [disabled]="formGroup?.invalid"
          type="submit"
        >
          {{ 'CONTINUE' | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
